import { render, staticRenderFns } from "./PortfolioPerformanceColumnChart.vue?vue&type=template&id=1682ee38&scoped=true&"
import script from "./PortfolioPerformanceColumnChart.vue?vue&type=script&lang=ts&"
export * from "./PortfolioPerformanceColumnChart.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioPerformanceColumnChart.vue?vue&type=style&index=0&id=1682ee38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682ee38",
  null
  
)

export default component.exports